import React, { useState, useEffect }  from 'react';
import { ResponsiveLine } from '@nivo/line';
import { Container, 
    Row, 
    Col, 
    Button, 
    Dropdown, 
    DropdownButton } from 'react-bootstrap';
import { GetCuentasFacturadasDias } from '../../Services/Net/Request/StatsService';
import Loading from '../Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSquare } from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';
import 'moment/locale/es';

export default function ChartFA(props)
{
    const [status, setStatus] = useState("");
    const [fechaInicial, setFechaInicial] = useState(moment().subtract(1, 'months'));
    const [fechaFinal, setFechaFinal] = useState(moment());
    const [chart, setChart] = useState();
    const [ncols, setNcols] = useState(0);
    const [filteron, setFilteron] = useState(false);
    const [rangetime, setRangetime] = useState(1);

    moment.locale('es');

    useEffect(() => {
        const abortController = new AbortController();
        setStatus("?");
        const formatdate = "YYYY-MM-DD HH:mm:ss";
    
        var Promise = GetCuentasFacturadasDias(abortController.signal,fechaInicial.format(formatdate),fechaFinal.format(formatdate));
    
        Promise.then(
          (response) => {
            if (abortController.signal.aborted)
              return;
    
            if (response.ok)
            {
              setStatus("");
              response.json().then((data) =>
              {
                setChart(data);
                //console.log(data);
                setNcols(data[0].data.length);
              });
            } else {
                setStatus("Error de conexión");
            }
          }
        ).catch(function(error) { 
          if (!abortController.signal.aborted)
              setStatus("Error de conexión: "+error); });
    
        return () => {
          abortController.abort();
          };
      },[fechaInicial,fechaFinal,props.hospital]);
    
      function ChangeRangeTime(nr)
      {
          setRangetime(nr);
          switch(nr)
          {
            case 0: //week
            
                setFechaFinal(moment());
                setFechaInicial(moment().subtract(1, 'weeks'));
            break;
            case 1: //month
            
                setFechaFinal(moment());
                setFechaInicial(moment().subtract(1, 'months'));
            break;
            case 2: //3 months
            
                setFechaFinal(moment());
                setFechaInicial(moment().subtract(3, 'months'));
            break;
            default:
            break;
          }
      }
  
      return(
          <Container fluid>
              <ChartFAControl
                  fechaInicial={fechaInicial}
                  fechaFinal={fechaFinal}
                  filteron={filteron}
                  rangetime={rangetime}
                  setfilteron={() => setFilteron(!filteron)}
                  setRangetime={(r) => ChangeRangeTime(r)}
                  />
              <Loading status={status}/>
              <Row style={
                  {width: (60*ncols).toString()+"px", height: "680px"}}
                  hidden={status === "?"}
                  >
                  <ResponsiveLine
                    data={chart}
                    margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                    yFormat=" >-$,.2f"
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        orient: 'bottom',
                        tickSize: 15,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'Dia',
                        legendOffset: 42,
                        legendPosition: 'middle'
                    }}
                    axisLeft={{
                        orient: 'left',
                        tickSize: 5,
                        tickPadding: 5,
                        legend: "",
                        legendOffset: -40,
                        legendPosition: 'middle',
                        format: " >-$,.0f",
                        tickRotation: 45
                    }}
                    colors={{ scheme: 'dark2' }}
                    pointSize={10}
                    pointColor={{ theme: 'background' }}
                    pointBorderWidth={2}
                    pointBorderColor={{ from: 'serieColor' }}
                    pointLabelYOffset={-12}
                    useMesh={true}
                    />
                </Row>
          </Container>
      )
}

function ChartFAControl(props)
{
    const [opacity, setOpacity] = useState(100);

    window.addEventListener("touchstart",ChartClick);
    window.addEventListener("touchend",ChartEndClick);

    useEffect(() => {
        return () => {
            window.removeEventListener('touchstart', () => {});
            window.removeEventListener('touchend', () => {});
          }
    },[]);

    function ChartClick(event)
    {
        setOpacity(50);
    }

    function ChartEndClick(event)
    {
        setOpacity(100);
    }

    return(
    <div style={{opacity: opacity.toString()+"%"}}>
        <div className="hlgp64">
            <Row style={{position: "fixed", zIndex: "1000", width: "100vw"}}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                <h2>Cuentas Facturadas</h2>
                <h4>{props.fechaInicial.format("D MMM YYYY")} al {props.fechaFinal.format("D MMM YYYY")}</h4>
                </Col>
                <Col xs={2} sm={2} md={2} lg={2} xl={2} className="tc">
                <Button style={{marginTop: "24px"}} variant="secondary" onClick={() => props.setfilteron()}>
                    <FontAwesomeIcon icon={faFilter} />
                </Button>
                </Col>
            </Row>
        </div>
        <div className="p8">
            <Row style={{position: "fixed", zIndex: "1000", width: "100vw"}}>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{color: "#1b9e77"}}>
                    <FontAwesomeIcon icon={faSquare}/> PAGADO
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{color: "#d95f02"}}>
                    <FontAwesomeIcon icon={faSquare}/> ADEUDO
                </Col>
            </Row>
        </div>
        <ChartFAFilters 
            filteron={props.filteron}
            rangetime={props.rangetime}
            setRangetime={(r) => props.setRangetime(r)}
            />
    </div>
  );
}

function ChartFAFilters(props)
{
    const RangeTimelabs = ["Semana","Mes","Trimestre"]

    if (props.filteron)
    {
        return(
            <div className="p8 hlgp64">
                <Row style={{position: "fixed", zIndex: "1000"}}>
                    <Col>
                        <small className="gray">Tiempo</small>
                        <DropdownButton title={RangeTimelabs[props.rangetime]} variant="secondary">
                            <Dropdown.Item 
                                onClick={() => props.setRangetime(0)} 
                            >
                                Semana
                            </Dropdown.Item>
                            <Dropdown.Item 
                                onClick={() => props.setRangetime(1)}
                            >
                                Mes
                            </Dropdown.Item>
                            <Dropdown.Item 
                                onClick={() => props.setRangetime(2)} 
                            >
                                Trimestre
                            </Dropdown.Item>
                        </DropdownButton>
                    </Col>
                </Row>
            </div>
        );
    } else {
        return(<></>);
    }
}